import { createFileRoute } from "@tanstack/react-router";

import { useT } from "../../app/i18n";
import { ForgotPasswordForm } from "../../features/auth/password-reset-forms";

export const Route = createFileRoute("/_auth/forgot-password")({ component: ForgotPasswordPage });

function ForgotPasswordPage() {
  const { t } = useT();
  return (
    <>
      <h1 className="mb-6 text-xl font-semibold">{t("auth:forgot.title")}</h1>
      <ForgotPasswordForm />
    </>
  );
}
